import * as Sentry from "@sentry/react";
import useOnMount from "src/hooks/useOnMount";

const useSentryReplayHook = () => {
  useOnMount(() => {
    const client = Sentry.getClient();

    // Check if Replay integration already exists to prevent multiple instances
    const existingReplay = client?.getIntegrationByName("Replay");
    if (existingReplay) {
      return; // Already initialized, don't add another
    }

    Sentry.addIntegration(
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      })
    );
  });
};

export default useSentryReplayHook;
